<ng-container *ngIf="tender;else noData">
  <app-widget-funding-tender-specifications *ngIf="TenderStatus.DRAFT === tender.status ||
                                                   TenderStatus.INITIALIZED === tender.status"
                                            [tender]="tender" [widget]="widget" (actionEvent)="actionEvent">
  </app-widget-funding-tender-specifications>
  <app-widget-funding-tender-published *ngIf="TenderStatus.READY_TO_PUBLISH === tender.status ||
                                              TenderStatus.PUBLISHED === tender.status"
                                       [tender]="tender"
                                       [widget]="widget" (actionEvent)="actionEvent">
  </app-widget-funding-tender-published>
  <app-widget-funding-tender-ongoing-analysis *ngIf="TenderStatus.ONGOING_ANALYSIS === tender.status"
                                              [tender]="tender" [widget]="widget"
                                              (actionEvent)="actionEvent">
  </app-widget-funding-tender-ongoing-analysis>
</ng-container>

<ng-template #noData>
  <app-widget-message (actionEvent)="trackAction($event)"
                      [actionLabel]="'widget.funding-tender.analyse-offers' | translate"
                      [callToActionButtonLabel]="'widget.funding-tender.create-new-tender' | translate"
                      [callToActionHref]="goToFundingTenderDashboardPage()"
                      [message]="'widget.funding-tender.no-tender-in-progress'| translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
</ng-template>

